import Vue from 'vue'
import Router from 'vue-router'
import 'firebase/auth'

import Home from '@/views/Home/Home'
import Shop from '@/views/Shop/Shop'
import Login from '@/views/Account/Login'
import SignUp from '@/views/Account/SignUp'
import Safety from "@/views/Safety/Safety.vue";
import Faq from "@/views/Faq/Faq.vue";
import Contact from "@/views/Contact/Contact.vue";
import { auth } from "@/firebase";
import { getIdTokenResult } from "firebase/auth"
import Admin from "@/views/Admin/Admin.vue";
import AdminProducts from "@/views/Admin/AdminProducts.vue";
import AdminOrders from "@/views/Admin/AdminOrders.vue";
import Checkout from "@/views/Checkout/Checkout.vue";
import SuccessPage from "@/views/Checkout/SuccessPage.vue";
import Track from "@/views/Track/Track.vue";
import Reviews from "@/views/Review/Review.vue"

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/shop',
        component: Shop
    },
    {
        path: '/safety',
        component: Safety
    },
    {
        path: '/review',
        component: Reviews
    },
    {
        path: '/faq',
        component: Faq
    },
    {
        path: '/contact',
        component: Contact
    },
    {
        path: '/track',
        component: Track
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/signup',
        component: SignUp
    },
    {
        path: '/checkout',
        component: Checkout
    },
    {
        path: '/checkout/success',
        component: SuccessPage
    },
    {
        path: '/admin',
        name: 'admin',
        component: Admin,
        meta: { requiresAdmin: true }
    },
    {
        path: '/admin/products',
        name: 'admin-products',
        component: AdminProducts,
        meta: { requiresAdmin: true }
    },
    {
        path: '/admin/orders',
        name: 'admin-orders',
        component: AdminOrders,
        meta: { requiresAdmin: true }
    }
]

const router = new Router({
    routes,
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    const currentUser = auth.currentUser;
    if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (currentUser) {
            getIdTokenResult(currentUser)
                .then(idTokenResult => {
                    console.log(idTokenResult);
                    if (idTokenResult.claims.admin) {
                        next();
                    } else {
                        next('/');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching custom claims:', error);
                    next('/');
                });
        } else {
            next('/login');
        }
    } else {
        next();
    }
});

export default router
